import { render, staticRenderFns } from "./National-series.vue?vue&type=template&id=983a8b42&scoped=true&"
import script from "./National-series.vue?vue&type=script&lang=js&"
export * from "./National-series.vue?vue&type=script&lang=js&"
import style0 from "./National-series.vue?vue&type=style&index=0&id=983a8b42&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "983a8b42",
  null
  
)

export default component.exports